import { Button, useMediaQuery, useTheme } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../Components/ComboBox'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import { currentDate } from '../../../utils/helpers'
import urls from '../../../utils/urls'
import AddCircleIcon from '@mui/icons-material/AddCircle'

export default function CreateMyPlantForm({ setOperations }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(undefined)
  const [plant, setPlant] = useState([])
  const [selectedPlant, setSelectedPlant] = useState(null)

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Nom: '',
      Nombre: '',
      CultureType: '',
      LastWat: '',
      LastFert: '',
      LastRempot: '',
      Emplacement: '',
    },
  })

  function currentDate() {
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const handleClickOpen = () => {
    setOpen(true)
    getPlantList()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      Nom: data.plant.id,
      CultureType: data.CultureType.id,
      Nombre: data.Nombre,
      LastWat: data.LastWat,
      LastFert: data.LastFert,
      LastRempot: data.LastRempot,
      Emplacement: data.Emplacement,
    }
    const response = await makePostRequest('/api/garden/crudPlant/', payload, {}, true)
    if (response.status === 201) {
      response.data.Nom = response.data.nom
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }

  const getPlantList = async () => {
    const url = urls.getPlantList
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const transformedData = data.results.map((plant) => {
        return { id: plant.id, label: plant.Nom }
      })
      setPlant(transformedData)
    }
  }

  useEffect(() => {
    getPlantList()
  }, [])

  const handlePlantChange = (event) => {
    setSelectedPlant(event.target.value)
  }

  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Ajout plante</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('plant', j)
              }}
              label="Plantes"
              data={plant}
              name="plant"
              required={true}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('CultureType', j)}
              label="Type de culture"
              data={[
                { label: 'Pot', id: 'Pot' },
                { label: 'Sol', id: 'Sol' },
              ]}
              name="CultureType"
              required={true}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
                step: '1',
              }}
              name="Nombre"
              label="Nombre de plantes"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                id: 'Dernier arrosage',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastWat"
              label="Dernier arrosage"
            />

            {/* // Ajouter un bouton pour mettre la date courante dans l'input date */}
            <button onClick={() => setValue('LastWat', currentDate())}>Today</button>

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastFert"
              label="Dernier apport d'/engrais"
            />

            <button onClick={() => setValue('LastFert', currentDate())}>Today</button>

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
                defaultValue: new Date().toISOString().substr(0, 10),
              }}
              name="LastRempot"
              label="Dernier rempotage"
            />

            <button onClick={() => setValue('LastRempot', currentDate())}>Today</button>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
              }}
              name="Emplacement"
              label="Emplacement"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
